"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryDetail = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var financialLecture_1 = require("../../model/financialLecture");
var service_1 = require("../../../library/base/service");
var QueryDetail = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(QueryDetail, _super);
    function QueryDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '金融微讲堂详情';
        _this.code = '101139';
        _this.desc = "\u91D1\u878D\u5FAE\u8BB2\u5802\u8BE6\u60C5";
        _this.requestParams = new financialLecture_1.QueryDetailRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return QueryDetail;
}(service_1.BaseService));
exports.QueryDetail = QueryDetail;
//# sourceMappingURL=queryDetail.js.map